import { connect } from '@cerebral/react'
import { sequences, state } from 'cerebral'
import { Field, Formik } from 'formik'
import { TextField } from 'formik-mui'
import React, { useCallback, useEffect } from 'react'
import ConfirmDialog from '../controls/ConfirmDialog'
import { Box, Container, Typography } from '@mui/material'

const ProfileModal = connect(
  {
    id: state`account.currentProfile._id`,
    name: state`account.currentProfile.name`,
    visible: state`account.profileModalVisible`,
    hideProfileModal: sequences`account.hideProfileModal`,
    patch: sequences`profiles.patch`,
  },

  (props) => ({ ...props, hideProfileModal: () => props.hideProfileModal() }),

  ({ id, name, visible, hideProfileModal, patch }) => {
    const onSubmit = useCallback(
      (values) => {
        patch({ id, values })
      },
      [patch, id]
    )

    return (
      <Formik initialValues={{ name }} enableReinitialize onSubmit={onSubmit}>
        {({ values, setFieldValue, submitForm }) => {
          useEffect(() => {
            if (visible && values.name?.first?.includes('@')) {
              setFieldValue('name.first', values.name.first.split('@')[0])
            }
          }, [visible, setFieldValue, values.name?.first])

          return (
            <ConfirmDialog open={visible} onConfirm={submitForm} onClose={hideProfileModal} confirmText="Save">
              <Container maxWidth="xs">
                <Typography variant="body1">Please tell us a little more about yourself to fill out your profile:</Typography>
                <Box my={2}>
                  <Field label="Your First Name" name="name.first" component={TextField} />
                  <Field label="Your Last Name" name="name.last" component={TextField} />
                </Box>
              </Container>
            </ConfirmDialog>
          )
        }}
      </Formik>
    )
  }
)

export default ProfileModal
